import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

class PaymentController extends Controller {
  connect() {
    this.onPaymentMethodChange();
  }

  onPaymentMethodChange() {
    this.disableSubmit(false);
  }

  onSubmit(e) {
    if (this.formHasErrors()) {
      e.preventDefault();
    }

    this.disableSubmit(true);
  }

  disableSubmit(state) {
    this.submitTarget[state ? 'setAttribute' : 'removeAttribute']('disabled', true);
  }

  formHasErrors() {
    const errors = toArray(this.formTarget.querySelectorAll('.parsley-errors-list.filled'));

    return errors.length > 0;
  }
}

PaymentController.targets = [
  'form',
  'submit',
  'paymentMethod',
];

export default PaymentController;
